<template>
  <div class="community-component container mt-4">
    <TopNav
      :title="$t('GENERAL.LABEL.PODCASTS')"
      :showOpenMainNav="true"
      :icon="['far', 'comments']"
    >
      <NavItem
        icon="far fa-plus"
        :text="$t('PODCASTS.LINK.ADD_PODCAST')"
        @click="addPodcast"
      />
    </TopNav>
    <div class="container-fluid text-center vh-100 pt-5" v-if="inProcess">
      <HMSpinner class="mt-4" />
    </div>
    <div class="d-flex mt-5" v-else-if="podcasts && podcasts.length > 0">
      <div class="community-groups w-100 d-flex flex-wrap">
        <div
          v-for="podcast in podcasts"
          :key="podcast.id"
          class="community-groups-container pr-3 pb-3"
        >
          <PodcastCard
            :podcast="podcast"
            @loadPodcasts="loadPodcasts"
            @showUpgradeYourPlanModal="showUpgradeYourPlanModal"
          />
        </div>
      </div>
    </div>
    <div v-else class="text-center mt-6 border rounded pb-6 pt-4">
      <HMEmpty
        image=""
        :title="$t('PODCASTS.TEXT.EMPTY_PODCASTS_TITLE')"
        :description="$t('PODCASTS.TEXT.EMPTY_PODCASTS_DESCRIPTION')"
      />
      <button
        @click="addPodcast"
        type="button"
        name="button"
        class="btn btn-primary"
      >
        {{ $t('PODCASTS.LINK.ADD_PODCAST') }}
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';
import UpgradeYourPlanModal from '@/web/components/settings/UpgradeYourPlanModal.vue';
import PodcastCard from '@/web/components/podcasts/PodcastCard';

export default Vue.extend({
  name: 'Podcasts',
  components: {
    PodcastCard,
    TopNav,
    NavItem,
  },
  data() {
    return {
      inProcess: true,
      upgradePlanDescription: null,
    };
  },
  computed: {
    ...mapGetters({
      teacher: 'user/teacher',
      podcasts: 'podcasts/podcasts',
    }),
    publishedPodcastsCount() {
      return this.podcasts.filter(item => item.active)?.length;
    },
    isReachedLimit() {
      return this.teacher.max_podcasts == this.publishedPodcastsCount;
    },
  },
  methods: {
    async loadPodcasts() {
      try {
        this.inProcess = true;
        await this.$store.dispatch('podcasts/loadPodcasts');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }
    },
    addPodcast() {
      if (this.isReachedLimit) {
        this.showUpgradeYourPlanModal();
      } else {
        this._addPodcast();
      }
    },
    async _addPodcast() {
      try {
        this.inProcess = true;
        const newPodcast = await this.$store.dispatch('podcasts/addPodcast', {
          title: 'New Podcast',
        });
        this.$router.push({
          name: 'Edit podcast',
          params: { id: newPodcast.id },
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR'),
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.inProcess = false;
      }
    },
    showUpgradeYourPlanModal() {
      this.$modal.show(UpgradeYourPlanModal, {
        description: this.upgradePlanDescription,
      });
    },
  },
  mounted() {
    this.loadPodcasts();
  },
  watch: {
    publishedPodcastsCount: {
      handler(value) {
        this.upgradePlanDescription = this.$tc(
          'PODCASTS.TEXT.YOUR_PLAN_SUPPORTS_UP_TO_PODCASTS',
          this.teacher.max_community_groups,
          this.activeGroupsCount,
          {
            limit: this.teacher.max_podcasts,
            activePodcastCount: this.publishedPodcastsCount,
          }
        );
      },
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.disabled {
  pointer-events: none;
  opacity: 0.5;
}
</style>
